import { useEffect, useRef, useState } from 'react';
import MembershipCarePlansEdit from './MembershipCarePlansEdit';
import WebUniversal, { WebUniversalProps } from '../../system/WebUniversal';
import { columnsheadId } from '../../universal/columnshead';
import { Select, Space } from 'antd';
import dayjs from 'dayjs';
import MembershipRechargePlansApplicablesMerchants from './MembershipRechargePlansApplicablesMerchants';
import fetchApi from '../../../utilsTsx/components/system/fetchApi';
import getList from '../../../utilsTsx/universal/getList';

const WebComponent = (props: any) => {
    const ref = useRef<any>(undefined);
    const apiId = 'membershipCarePlans';
    const [membershipRechargePlansId, setMembershipRechargePlansId] = useState<any>();
    const [modalVisibleMembershipRechargePlansApplicablesMerchants,
        setModalVisibleMembershipRechargePlansApplicablesMerchants] = useState<any>();

    /** 后端数据defaultService */
    const [defaultService, setDefaultService] = useState<string>('');
    const [membershipTypeData, setMembershipTypeData] = useState<any>();
    const [membershipCarePlansModelData, setMembershipCarePlansModelData] = useState<any>();
    const [fethcData, setFethcData] = useState<any>();
    const [sendPageData, setSendPageData] = useState<any>({
        showPageData: {}
    });

    useEffect(() => {
        let urlService;
        if (ref.current) {
            urlService = ref.current.defaultService;
            setDefaultService(urlService);
            setFethcData(() => ref.current.fetchData);
        }
        fetchApi.GET(urlService,
            {
                query: {
                    apiId: 'membershipType',
                    apiExtend: 'showList'
                }
            }).then(res => {
                if (res.success) {
                    setMembershipTypeData([{ id: 'allMembershipType', typeName: '所有' }, ...res.data]);
                }
            });
        fetchApi.GET(urlService,
            {
                query: {
                    apiId: 'generalData',
                    apiVariable: 'membershipCarePlansModel',
                    apiExtend: 'showLists'
                }
            }).then(res => {
                if (res.success) {
                    const { membershipCarePlansModel } = res.data;
                    setMembershipCarePlansModelData([{ id: 'allMembershipCarePlansModel', name: '所有' }, ...membershipCarePlansModel]);
                }
            })
    }, []);

    //表头
    const columnsHead = [
        {
            title: '方案',
            dataIndex: 'planName',
        },
        {
            title: '模式',
            dataIndex: 'membershipCarePlansModel',
            render: (text: any) => text?.name
        },
        {
            title: '会员类别',
            dataIndex: 'membershipType',
            render: (text: any) => text?.typeName
        },
        {
            title: '使用规则',
            dataIndex: 'isPermanentUse',
            render: (val: boolean, record: any) => {
                return (
                    val === true ?
                        '永久使用' :
                        `${dayjs(record?.startDate).format('YYYY-MM-DD')} 至 ` +
                        `${dayjs(record?.endDate).format('YYYY-MM-DD')}；` +
                        `${record?.totalCopies - record?.usedCopies}/${record?.totalCopies}`
                )
            }
        }
    ];

    const columns = columnsheadId
        .concat(columnsHead as []);

    let extendProps: WebUniversalProps = {
        ...props,
        titleName: '会员关怀方案',
        apiId,
        columns,
        serviceId: 'business',
        editOptions: {
            Editor: MembershipCarePlansEdit
        }
    };

    return (
        <><Space>
            <Select
                showSearch
                placeholder="模式"
                optionFilterProp="children"
                defaultValue={'allMembershipCarePlansModel'}
                onChange={(e) => {
                    const cs = {
                        showPageData: {
                            ...sendPageData.showPageData,
                            membershipCarePlansModelId: e
                        }
                    }
                    setSendPageData(cs);
                    fethcData({
                        apiId,
                        sendPageData: cs
                    });
                }}
                style={{ width: 130 }}
                filterOption={(input, option: any) =>
                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                {getList.general(membershipCarePlansModelData)}
            </Select>
            <Select
                showSearch
                placeholder="会员类型"
                optionFilterProp="children"
                defaultValue={'allMembershipType'}
                onChange={(e) => {
                    const cs = {
                        showPageData: {
                            ...sendPageData.showPageData,
                            membershipTypeId: e
                        }
                    }
                    setSendPageData(cs);
                    fethcData({
                        apiId,
                        sendPageData: cs
                    });
                }}
                style={{ width: 130 }}
                filterOption={(input, option: any) =>
                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                {getList.general(membershipTypeData, { itemName: 'typeName' })}
            </Select>
        </Space>
            <> </>
            <WebUniversal {...extendProps} ref={ref} />
            {modalVisibleMembershipRechargePlansApplicablesMerchants ?
                (<MembershipRechargePlansApplicablesMerchants
                    closeModal={() => setModalVisibleMembershipRechargePlansApplicablesMerchants(false)}
                    data={membershipRechargePlansId} />)
                : null}
        </>
    )
}

export default WebComponent;
